export const MAP_INITIAL_ZOOM = 7;
export const MAP_ZOOM_SNAP = 0.1;
export const MAP_MIN_ZOOM = 3;
export const MAP_MAX_ZOOM = 18;
export const MAP_BOUNDARY_VISCOSITY = 0.95;

/**
 * MapLibre's top-left control stack (maplibre-gl.css): 29px buttons, 10px between one group and the next.
 *
 * Some screens hand-place their own buttons to continue it (`top: 78px` = the 10px inset, the zoom group,
 * one gap). The host publishes in `extraHeightVar` how much taller it made the stack — the place-info
 * switch is one more group — and those screens add it to their `top`, so the two never overlap.
 */
export const MAP_CONTROL_STACK = {
  buttonSizePx: 29,
  groupGapPx: 10,
  extraHeightVar: "--map-control-stack-extra-height",
} as const;
